'use strict'

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

if document.referrer is url or document.referrer.indexOf('case/') isnt -1 or document.referrer.indexOf('contents/') isnt -1
  $(
    if (navigator.userAgent.indexOf('Opera') isnt -1)
    then (
      if document.compatMode is 'BackCompat'
      then 'body'
      else 'html'
    )
    else 'html, body'
  ).animate({
    scrollTop: $('.p-details').offset().top - $('.p-header > .headroom').outerHeight()
  }, 0)
